import { Grid, Button } from "@material-ui/core";
import { NavLink } from "react-router-dom";

export default function NotFoundPage(props) {
  return (
    <Grid container>
      <Grid item xs={12}>
        <div style={{ padding: "40px 15px", textAlign: "center" }}>
          <h1>Oops!</h1>
          <h2>404 Not Found</h2>
          <div>Sorry, an error has occured, Requested page not found!</div>
          {/*
            <div style={{ marginTop: 15 }}>
              <NavLink to="/">
                <Button variant="outlined" color="primary">
                  Home
                </Button>
              </NavLink>
            </div>
        */}
        </div>
      </Grid>
    </Grid>
  );
}
